module.exports = __webpack_public_path__ + "static/shipkoo-express-plus-packages-5db5b1b582cc422742752b997a6fcc52.png";